import styled from "styled-components";

// This styled component should wrapp the injected EmissionLabel webcomponent
// So the emission label will have always the same height because of the different heights that has the emmissionlabel webcomponent
export const EmmisionLabelWrapper = styled.dd`
    height: 32px;
`;

export default EmmisionLabelWrapper;
